<template>
  <!-- <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
  </div> -->
  <div class="body">
    <barra-lateral v-show="autenticado"></barra-lateral>

    <!-- Main content -->
    <div class="main-content" id="panel">
      <barra-superior v-show="autenticado"></barra-superior>

      <!-- Page content -->
      <div class="container-fluid">
        <router-view />
      </div>
      <!-- Page content -->
    </div>

    <div id="notifikation"></div>
  </div>
</template>

<script>
// Closure
(function() {
  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === "undefined" || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
      return NaN;
    }
    // If the value is negative...
    if (value < 0) {
      return -decimalAdjust(type, -value, exp);
    }
    // Shift
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
  }

  // Decimal round
  if (!Math.round10) {
    Math.round10 = function(value, exp) {
      return decimalAdjust("round", value, exp);
    };
  }
  // Decimal floor
  if (!Math.floor10) {
    Math.floor10 = function(value, exp) {
      return decimalAdjust("floor", value, exp);
    };
  }
  // Decimal ceil
  if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
      return decimalAdjust("ceil", value, exp);
    };
  }
})();
import BarraSuperior from "@/components/Navegacion/BarraSuperior.vue";
import BarraLateral from "@/components/Navegacion/BarraLateral.vue";
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({
    image: require("@/assets/img/brand/blue.png")
  }),
  created() {
    //console.log(window.location.href);
    let url = window.location.href;
    let backend_local = process.env.VUE_APP_BACKEND_LOCAL;
    //let backend_external = process.env.VUE_APP_BACKEND_EXTERNAL;
    let environment = process.env.NODE_ENV;

    let base = null;

    console.log(`ENVIRONMENT: ${process.env.NODE_ENV}`);
    console.log(`BACKEND LOCAL: ${process.env.VUE_APP_BACKEND_LOCAL}`);
    console.log(`BACKEND EXTERNAL: ${process.env.VUE_APP_BACKEND_EXTERNAL}`);

    if (environment == "development") {
      base = backend_local;
    }

    if (environment == "production") {
      base = backend_local;
    }

    /*if (url.includes("10.10.6.3")) {
      //red interna la portada
      base = backend_local;
    }

    if (url.includes("190.13.184.67")) {
      //acceso externo
      base = backend_external;
    }*/

    this.actualizar_base({
      api: `${base}/api`,
      api_public: base
    });

    // if (url.includes("192.168.1.164") || url.includes("localhost")) {
    //   this.actualizar_base({
    //     api: "http://localhost:8000/api",
    //     api_public: "http://localhost:8000"
    //   });
    //   //this.actualizar_base({api:'http://192.168.1.164:81/romana2/backend/public/api',api_public:'http://192.168.1.164:444/romana2/backend/public'})
    // } else if (url.includes("192.168.205.150")) {
    //   this.actualizar_base({
    //     api: "https://192.168.205.150:444/romana2/backend/public/api",
    //     api_public: "https://192.168.205.150:444/romana2/backend/public"
    //   });
    // } else if (url.includes("190.13.184.67")) {
    //   this.actualizar_base({
    //     api: "https://190.13.184.67:444/romana2/backend/public/api",
    //     api_public: "https://190.13.184.67:444/romana2/backend/public"
    //   });
    // }

    this.$socket.on("connect", () => {
      console.log(this.$socket.id); // x8WIv7-mJelg7on_ALbx
    });
  },
  mounted() {
    this.$socket.on("new_update", msg => {
      this.$swal({
        title: "Actualización Detectada!",
        text: msg,
        icon: "info",
        confirmButtonText: "Si, Recargar",
        toast: true,
        position: "top",
        denyButtonColor: "#5e72e4",
        confirmButtonColor: "#113378",
        //timer:8000,
        timerProgressBar: true,
        allowOutsideClick: true,
        showDenyButton: true,
        denyButtonText: "Lo haré después",
        width: "35rem"
      }).then(result => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    });
  },
  methods: {
    ...mapActions(["actualizar_base"])
  },
  computed: {
    ...mapState(["autenticado"])
  },
  components: {
    "barra-superior": BarraSuperior,
    "barra-lateral": BarraLateral
  }
};
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */

background-gray {
  background-color: #c2c0c0;
}
.bg-petroleo {
  background-color: #caf0f8;
}
</style>
